import Post01 from '../data/img/insPosts/post-01.png';
import Post02 from '../data/img/insPosts/post-02.png';
import Post03 from '../data/img/insPosts/post-03.png';
import Post04 from '../data/img/insPosts/post-04.png';
import Post05 from '../data/img/insPosts/post-05.png';

const instsgramImg = [
  { src: Post01, alt: 'post-01' },
  { src: Post02, alt: 'post-02' },
  { src: Post03, alt: 'post-03' },
  { src: Post04, alt: 'post-04' },
  { src: Post05, alt: 'post-05' },
];

export default instsgramImg;
